import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { orderBy, sortBy } from 'lodash-es';
import { SECOND_MAPPING_COLUMN } from '~/integrations/IntegrationMappingModal/IntegrationMappingModal.utils';
import { serviceTemplateModel } from '~/models';
import { isStanfordTaxReturnType } from '~/models/ServiceIntegrations';
import { editStanfordTaxMapping, stanfordTaxYearOptions } from '~/utils/stanfordTaxMappingOptions';
export const mappingOverlayState = (param)=>{
    let { isLoading, hasError, serviceTemplates } = param;
    if (isLoading) return 'loading';
    if (hasError) return 'error';
    return serviceTemplates.length ? 'valid' : 'empty';
};
export const buildStanfordTaxMappingRows = (serviceTemplates, texts)=>sortBy(orderBy(serviceTemplates, [
        'name'
    ], [
        'asc'
    ]), serviceTemplateModel.isDeleted).map((serviceTemplate)=>{
        var _ref;
        const mapping = serviceTemplate.integrations.stanfordTaxMapping();
        return {
            id: serviceTemplate.id,
            anchor: serviceTemplateModel.isDeleted(serviceTemplate) ? texts.archivedName({
                name: serviceTemplate.name
            }) : serviceTemplate.name,
            mapping: (_ref = mapping === null || mapping === void 0 ? void 0 : mapping.returnType) !== null && _ref !== void 0 ? _ref : '',
            secondMapping: mapping ? String(mapping.taxYear) : '',
            status: mapping ? 'mapped' : 'notMapped'
        };
    });
const rowStanfordTaxMapping = (row)=>isStanfordTaxReturnType(row.mapping) ? {
        returnType: row.mapping,
        taxYear: Number(row.secondMapping)
    } : undefined;
export const resolveStanfordTaxRowChange = (param)=>{
    let { row, columnId, value, now } = param;
    return editStanfordTaxMapping({
        mapping: rowStanfordTaxMapping(row),
        edit: columnId === SECOND_MAPPING_COLUMN ? {
            taxYear: Number(value)
        } : {
            returnType: value
        },
        now
    });
};
export const withSavedStanfordTaxMapping = (param)=>{
    let { templateId, rereadTemplate, mapping } = param;
    return (templates)=>templates.map((template)=>{
            if (template.id !== templateId) return template;
            return rereadTemplate !== null && rereadTemplate !== void 0 ? rereadTemplate : _object_spread_props(_object_spread({}, template), {
                integrations: template.integrations.setStanfordTaxMapping(mapping)
            });
        });
};
export const stanfordTaxYearSelectOptions = (now, row)=>stanfordTaxYearOptions(now, row.secondMapping ? Number(row.secondMapping) : undefined).map((year)=>({
            value: String(year),
            label: String(year)
        }));
